import { useQuery } from '@tanstack/react-query';
import ActivityStatus from '../../../enums/activities/ActivityStatus';
import { getAxios } from '../../../lib/axios';
import { QueryKeys } from '../../../constants/queryKeys';
import { SelectOption } from '@cks-internal/react-base';
import { HotelBookingMethod } from '../../../globalModels/common/hotelBookingMethod';
import { HotelBookingType } from '../../../globalModels/common/hotelBookingType';
import { ActivitySertifiCanaryStatus } from '../../../enums/activities/ActivitySertifiCanaryStatus';
import { ActivityPaymentEmailStatus } from '../../../enums/activities/ActivityPaymentEmailStatus';
import { ActivityHotelPaymentStatus } from '../../../enums/activities/ActivityHotelPaymentStatus';
import { CompanyPaymentType } from '../../../features/company/edit/types/companyPaymentType.ts';
import { CompanyCardOnFileModel } from '../../../features/crm/creditCards/types/types.ts';
import { ActivityEndpoints } from '../../../constants/endpoints/activityEndpoints.ts';

export type TravellerNameIdModel = {
  Id: number;
  FirstName: string;
  LastName: string;
  FullName: string;
};

export type ActivityStatusModel = {
  ActivityHeader: string;
  ApprovedBookerId: number | undefined;
  AssignedToUserId?: string;
  AssignedToUserName?: string;
  CancellationHeader: string | undefined;
  CheckInDate: string | undefined;
  CheckOutDate: string | undefined;
  CompanyConfirmationId: number | undefined;
  CompanyId: number | undefined;
  CompanyName: string | undefined;
  DisableEdit: boolean;
  DuplicateGroupFlsqs: string[];
  FirstEmailSubject: string | undefined;
  Flsq?: number;
  HasBookedHotel: boolean;
  HasCorporateCardPayment: boolean;
  HasFormOfPayment?: boolean;
  HasItinerary: boolean;
  HasMandatoryReportingRequirements: boolean;
  HasPersonalTravelCard?: boolean;
  HasSelectedHotelRates: boolean;
  HasSentFolioRequest: boolean;
  HasSentItinerary: boolean;
  HasUnconfirmedCompany?: boolean;
  HasUnreadEmails: boolean;
  HasWexDirectPayment: boolean;
  HasActivityIssues: boolean;
  HotelBookingMethod: HotelBookingMethod;
  HotelBookingType: HotelBookingType;
  HotelPaymentStatus: ActivityHotelPaymentStatus;
  HotelRateIds: number[];
  Id: number;
  IsBetaBooking?: boolean;
  IsCancelled: boolean;
  IsLongTerm: boolean;
  IsObt: boolean;
  NumberOfTravellers: number;
  OtherCompanyPaymentCards: CompanyCardOnFileModel[];
  PaymentEmailStatus: ActivityPaymentEmailStatus;
  PaymentType: CompanyPaymentType | undefined;
  PreferredCity?: string;
  PreferredHotelId?: number;
  RequestedById: number | undefined;
  SelectedHotelId?: number;
  SelectedRateId?: number;
  SertifiCanaryStatus: ActivitySertifiCanaryStatus;
  Status: ActivityStatus;
  TabTitle: string;
  TravellerEnforcedPersonal: boolean;
  TravellerSelectOptions: SelectOption[];
  Travellers: TravellerNameIdModel[];
  WaitingSince?: string;
  IsPendingApproval: boolean;
  ObtApprovalsEnabled: boolean;
  AgentApprovalsEnabled: boolean;
};

export function useActivityStatusQuery(activityId: number | undefined, key?: string) {
  return useQuery<ActivityStatusModel>({
    queryKey: [
      key ?? QueryKeys.editActivity(activityId ?? -1),
      ActivityEndpoints.activityStatus(activityId ?? -1),
      activityId
    ],
    queryFn: async () => (await getAxios().get(`${ActivityEndpoints.activityStatus(activityId ?? -1)}`)).data,
    enabled: !!activityId && !isNaN(activityId),
    retry: false
  });
}
